export function acceptCookies({ all }: { all: boolean }) {
  if (!all) {
    localStorage.setItem("Cookies", "Necessário");
    return;
  }
  localStorage.setItem("Cookies", "Todos");
}
